import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import "../styles_web/Animations.css";
import css from "../styles_web/HeaderProfile.module.css";
import HeaderProfilePopperMenu from "./HeaderProfilePopperMenu";
import RewardsBox from "./RewardsBox";
import Image from "../components/shared/Image";

/************************************/
/* Header Profile */
/************************************/
const HeaderProfile = ({
  userName,
  storeName,
  storeLogo,
  profileTitle,
  profileMenu,
  authMenu,
  rewards,
  onSignInOut,
}) => {
  const buttonRef = useRef();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleProfileMenu = (e) => {
    if (e.target && buttonRef?.current?.contains(e.target)) {
      setMenuOpen(!menuOpen);
    }
  };

  const closeProfileMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div className={css["profile"]}>
      {rewards && (
        <RewardsBox
          tier={rewards.tier}
          tierLabel={rewards.tierLabel}
          points={rewards.points}
          info={rewards.info}
          nextTier={rewards.nextTier}
          nextTierLabel={rewards.nextTierLabel}
          nextTierSpend={rewards.nextTierSpend}
          tierProgressPercent={rewards.tierProgressPercent}
          isFirstTier={rewards.isFirstTier}
          isLastTier={rewards.isLastTier}
          expiring={rewards.expiring}
          expiringPoints={rewards.expiringPoints}
        ></RewardsBox>
      )}
      {storeLogo && (
        <div className={css["storeLogo"]}>
          <Image src={storeLogo} alt="logo" noCache={true} />
        </div>
      )}
      <div className={css["content"]} onClick={toggleProfileMenu}>
        <button
          id="Header_profileBtn"
          data-cy="Header_profileButton"
          className={css["button"]}
          ref={buttonRef}
        >
          <div className={css["button-content"]}>
            <span className={css["username"]}>{userName}</span>
            {storeName && <span className={css["storename"]}>{storeName}</span>}
          </div>
          <span className={css["button-arrow"]}></span>
        </button>

        {buttonRef.current && (
          <HeaderProfilePopperMenu
            isOpen={menuOpen}
            onClosed={closeProfileMenu}
            anchorEl={buttonRef.current}
            userName={userName}
            profileTitle={profileTitle}
            storeName={storeName}
            storeLogo={storeLogo}
            profileMenu={profileMenu}
            authMenu={authMenu}
            onSignInOut={onSignInOut}
          ></HeaderProfilePopperMenu>
        )}
      </div>
    </div>
  );
};

HeaderProfile.propTypes = {
  userName: PropTypes.string,
  storeName: PropTypes.string,
  storeLogo: PropTypes.string,
  profileTitle: PropTypes.string,
  profileMenu: PropTypes.array,
  authMenu: PropTypes.array,
  rewards: PropTypes.object,
  onSignInOut: PropTypes.func,
};

export default HeaderProfile;
